import { MDBInput, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { ASParamEditorProps } from "../ASParamEditor";

export const ASCoinChansParam = ({currentValue, onCurrentValueChange, disabled}: ASParamEditorProps<{pulses: number, value: number}[]>) => {
    
    return (          
        <MDBTable className="table-sm" style={{width: 350}}>
            <MDBTableHead>
                <tr>
                    <th scope="col" style={{width: 150}}>#</th>
                    <th scope="col" style={{width: 100}}>Pulses</th>
                    <th scope="col" style={{width: 100}}>Value</th>
                </tr>
            </MDBTableHead>
            <MDBTableBody>
                {Array.from(new Array(6)).map((_,idx) => (
                    <tr key={idx}>
                        <th scope="row" style={{width: 150, verticalAlign: 'middle'}}>
                            <span className="">Chan #{idx+1}</span>
                        </th>
                        <th >
                            <span>
                                <MDBInput
                                    type="number"
                                    value={currentValue == null ? "" : currentValue[idx].pulses} //(currentValue[idx] >> 24) & 0xFF}
                                    min={0}
                                    max={255}
                                    disabled={disabled}
                                    style={{height: 25}}
                                    onInput={ev => {
                                        const val = Number(ev.currentTarget.value);
                                        if (!currentValue) return;
                                        const newValue = [...currentValue];
                                        newValue[idx].pulses = val;
                                        onCurrentValueChange(newValue);
                                    }}
                                />
                            </span>
                        </th>
                        <th >
                            <span>
                                <MDBInput
                                    type="number"
                                    value={currentValue == null ? "" : currentValue[idx].value}//(currentValue[idx] >> 16) & 0xFF}
                                    min={0}
                                    max={255}
                                    disabled={disabled}
                                    style={{height: 25}}
                                    onInput={ev => {
                                        const val = Number(ev.currentTarget.value);
                                        if (!currentValue) return;
                                        const newValue = [...currentValue];
                                        newValue[idx].value = val;
                                        onCurrentValueChange(newValue);
                                    }}
                                />
                            </span>
                        </th>
                    </tr>
                ))}
            </MDBTableBody>
        </MDBTable>
    )
}